export default __webpack_public_path__ + "static/media/other-vehicles.8fe2ea7a.jpg";